function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.544 22.855l-.498-.399c-1.395-1.394-1.395-3.585 0-4.88L6.523 12 1.046 6.523c-1.395-1.394-1.395-3.585 0-4.88l.498-.597c1.394-1.395 3.585-1.395 4.88 0L12 6.622l5.477-5.576c1.394-1.395 3.585-1.395 4.88 0l.498.498c1.394 1.394 1.394 3.585 0 4.88L17.378 12l5.576 5.577c1.395 1.394 1.395 3.585 0 4.88l-.597.497c-1.394 1.395-3.585 1.395-4.88 0L11.9 17.378l-5.477 5.477c-1.294 1.394-3.485 1.394-4.88 0z",
  fillRule: "nonzero",
  fill: "#231F20"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;